import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
          meta: {
            rule: "admin",
            isAuth: true
          }
        },
        {
          path: "/news",
          name: "news",
          component: () => import("./views/news/News.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Новости", active: true }
            ],
            pageTitle: "Новости"
          }
        },
        {
          path: "/news/:id(\\d+)",
          name: "edit-news",
          component: () => import("./views/news/EditNews.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Новости", url: "/news" },
              { title: "Редактирование новости", active: true }
            ],
            pageTitle: "Редактирование новости",
            parent: "news"
          }
        },
        {
          path: "/news/new",
          name: "new-news",
          component: () => import("./views/news/NewNews.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Новости", url: "/news" },
              { title: "Создание новости", active: true }
            ],
            pageTitle: "Создание новости",
            parent: "news"
          }
        },
        {
          path: "/votings",
          name: "votings",
          component: () => import("./views/Votings.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Голосования", active: true }
            ],
            pageTitle: "Голосования"
          }
        },
        {
          path: "/passes",
          name: "passes",
          component: () => import("./views/passes/Passes.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Пропускная система", active: true }
            ],
            pageTitle: "Пропускная система"
          }
        },
        {
          path: "/passes/:id(\\d+)",
          name: "simple-pass",
          component: () => import("./views/passes/SimplePass.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Пропускная система", url: "/passes" },
              { title: "Подробнее о пропуске", active: true }
            ],
            pageTitle: "Подробнее о пропуске",
            parent: "passes"
          }
        },

        //Бронирование
        {
          path: "/booking/events",
          name: "booking-events",
          component: () => import("./views/booking/Events.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Мероприятия", active: true }
            ],
            pageTitle: "Мероприятия"
          }
        },
        {
          path: "/booking/categories",
          name: "booking-categories",
          component: () => import("./views/booking/Categories.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Категории бронирования", active: true }
            ],
            pageTitle: "Категории бронирования"
          }
        },
        //END Бронирование

        //Консьерж-Сервис
        {
          path: "/services/categories",
          name: "services-categories",
          component: () => import("./views/services/Categories.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Категории Консьерж-сервиса", active: true }
            ],
            pageTitle: "Категории Консьерж-сервиса"
          }
        },
        {
          path: "/services/category/:id(\\d+)",
          name: "edit-services-category",
          component: () => import("./views/services/category/EditCategory.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              {
                title: "Категории Консьерж-сервиса",
                url: "/services/categories"
              },
              {
                title: "Редактирование категории Консьерж-сервиса",
                active: true
              }
            ],
            pageTitle: "Редактирование категории Консьерж-сервиса",
            parent: "services-categories"
          }
        },
        {
          path: "/services/category/new",
          name: "new-services-category",
          component: () => import("./views/services/category/NewCategory.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              {
                title: "Категории Консьерж-сервиса",
                url: "/services/categories"
              },
              { title: "Создание категории Консьерж-сервиса", active: true }
            ],
            pageTitle: "Создание категории Консьерж-сервиса",
            parent: "services-categories"
          }
        },
        {
          path: "/security",
          name: "security",
          component: () => import("./views/security/Security.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Вызов охраны", active: true }
            ],
            pageTitle: "Вызов охраны"
          }
        },
        {
          path: "/security/:id(\\d+)",
          name: "simple-security",
          component: () => import("./views/security/SimpleSecurity.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Вызов охраны", url: "/security" },
              { title: "Заявка на вызов охраны", active: true }
            ],
            pageTitle: "Заявка на вызов охраны",
            parent: "security"
          }
        },
        //END Консьерж-сервис

        //Обращения
        {
          path: "/requests",
          name: "requests",
          component: () => import("./views/requests/Requests.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", active: true }
            ],
            pageTitle: "Заявки"
          }
        },
        {
          path: "/requests/application/new",
          name: "new-application",
          component: () => import("./views/requests/new/Application.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", url: "/requests" },
              { title: "Новая заявка", active: true }
            ],
            pageTitle: "Новая заявка"
          }
        },
        {
          path: "/requests/consierge/new",
          name: "new-consierge",
          component: () => import("./views/requests/new/Consierge.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", url: "/requests" },
              { title: "Новая заявка консьерж-сервиса", active: true }
            ],
            pageTitle: "Новая заявка консьерж-сервиса"
          }
        },
        //Общая Заявка, бывшая Ticket
        {
          path: "/requests/application/:id(\\d+)",
          name: "application",
          component: () => import("./views/requests/type/Application.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", url: "/requests" },
              { title: "Заявка", active: true }
            ],
            pageTitle: "Заявка",
            parent: "requests"
          }
        },
        //Консьерж-сервис
        {
          path: "/requests/consierge/:id(\\d+)",
          name: "consierge",
          component: () => import("./views/requests/type/Consierge.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", url: "/requests" },
              { title: "Заявка из Консьерж-сервиса", active: true }
            ],
            pageTitle: "Заявка из Консьерж-сервиса",
            parent: "requests"
          }
        },
        //Консьерж-сервис
        {
          path: "/requests/booking/:id(\\d+)",
          name: "booking",
          component: () => import("./views/requests/type/Booking.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заявки", url: "/requests" },
              { title: "Заявка на бронирование", active: true }
            ],
            pageTitle: "Заявка на бронирование",
            parent: "requests"
          }
        },
        //END Обращшения

        {
          path: "/sharing",
          name: "sharing",
          component: () => import("./views/Sharing.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Шеринг", active: true }
            ],
            pageTitle: "Шеринг"
          }
        },
        {
          path: "/cameras",
          name: "cameras",
          component: () => import("./views/Cameras.vue"),
          meta: {
            rule: "security",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Камеры", active: true }
            ],
            pageTitle: "Камеры"
          }
        },
        {
          path: "/residents",
          name: "residents",
          component: () => import("./views/users/Users.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Жители", active: true }
            ],
            pageTitle: "Жители"
          }
        },
        {
          path: "/residents/:id(\\d+)",
          name: "resident",
          component: () => import("./views/users/User.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Жители", url: "/residents" },
              { title: "Житель", active: true }
            ],
            pageTitle: "Житель",
            parent: "residents"
          }
        },
        {
          path: "/homes",
          name: "homes",
          component: () => import("./views/Homes.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Список адресов", active: true }
            ],
            pageTitle: "Список адресов"
          }
        },

        //Сотрудники
        {
          path: "/employees",
          name: "employees",
          component: () => import("./views/Employees.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Сотрудники", active: true }
            ],
            pageTitle: "Сотрудники"
          }
        },
        //END Сотрудники

        {
          path: "/communal-payments/tariffs",
          name: "communal-payments-tariffs",
          component: () => import("./views/communal-payments/Tariffs.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              { title: "Тарифы", active: true }
            ],
            pageTitle: "Тарифы"
          }
        },

        {
          path: "/communal-payments/bills",
          name: "communal-payments-bills",
          component: () => import("./views/communal-payments/bills/Bills.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              { title: "Счета", active: true }
            ],
            pageTitle: "Счета"
          }
        },
        {
          path: "/communal-payments/bills/:id(\\d+)",
          name: "communal-payments-bill",
          component: () => import("./views/communal-payments/bills/Bill.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              { title: "Счета", url: "/communal-payments/bills" },
              { title: "Счет", active: true }
            ],
            pageTitle: "Счет",
            parent: "communal-payments-bills"
          }
        },

        {
          path: "/communal-payments/personal-accounts",
          name: "communal-payments-personal-accounts",
          component: () =>
            import("./views/communal-payments/personal-accounts/Accounts.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              { title: "Лицевые счета", active: true }
            ],
            pageTitle: "Лицевые счета"
          }
        },
        {
          path: "/communal-payments/personal-accounts/new",
          name: "communal-payments-new-personal-account",
          component: () =>
            import(
              "./views/communal-payments/personal-accounts/NewAccount.vue"
            ),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              {
                title: "Лицевые счета",
                url: "/communal-payments/personal-accounts"
              },
              { title: "Новый Лицевой счет", active: true }
            ],
            pageTitle: "Новый Лицевой счет",
            parent: "communal-payments-personal-accounts"
          }
        },
        {
          path: "/communal-payments/personal-accounts/:id(\\d+)",
          name: "communal-payments-personal-account",
          component: () =>
            import("./views/communal-payments/personal-accounts/Account.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Коммунальные платежи" },
              {
                title: "Лицевые счета",
                url: "/communal-payments/personal-accounts"
              },
              { title: "Лицевой счет", active: true }
            ],
            pageTitle: "Лицевой счет",
            parent: "communal-payments-personal-accounts"
          }
        },

        {
          path: "/counters",
          name: "counters",
          component: () => import("./views/counters/Counters.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Счетчики", active: true }
            ],
            pageTitle: "Счетчики"
          }
        },
        {
          path: "/counters/:id(\\d+)",
          name: "counter",
          component: () => import("./views/counters/Counter.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Счетчики", url: "/counters" },
              { title: "Счетчик", active: true }
            ],
            pageTitle: "Счетчик",
            parent: "counters"
          }
        },

        {
          path: "/paid-services",
          name: "paid-services",
          component: () => import("./views/paid-services/PaidServices.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Платные услуги", active: true }
            ],
            pageTitle: "Платные услуги"
          }
        },
        {
          path: "/paid-services/:id(\\d+)",
          name: "paid-service",
          component: () => import("./views/paid-services/PaidService.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Платные услуги", url: "/paid-services" },
              { title: "Услуга", active: true }
            ],
            pageTitle: "Услуга",
            parent: "paid-services"
          }
        },

        {
          path: "/market/products",
          name: "market-products",
          component: () => import("./views/market/products/Products.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Товары", active: true }
            ],
            pageTitle: "Товары"
          }
        },
        {
          path: "/market/categories",
          name: "market-categories",
          component: () => import("./views/market/categories/Categories.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Категории товаров", active: true }
            ],
            pageTitle: "Категории товаров"
          }
        },
        {
          path: "/market/products/:id(\\d+)",
          name: "market-product",
          component: () => import("./views/market/products/Product.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Товары", url: "/market/products" },
              { title: "Товар", active: true }
            ],
            pageTitle: "Товар",
            parent: "market-products"
          }
        },
        {
          path: "/market/products/new",
          name: "new-market-product",
          component: () => import("./views/market/products/NewProduct.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Товары", url: "/market/products" },
              { title: "Новый товар", active: true }
            ],
            pageTitle: "Новый товар",
            parent: "market-products"
          }
        },
        {
          path: "/market/orders",
          name: "market-orders",
          component: () => import("./views/market/orders/Orders.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заказы в Маркете", active: true }
            ],
            pageTitle: "Заказы в Маркете"
          }
        },
        {
          path: "/market/orders/:id(\\d+)",
          name: "market-order",
          component: () => import("./views/market/orders/Order.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заказы в Маркете", url: "/market/orders" },
              { title: "Заказ", active: true }
            ],
            pageTitle: "Заказ",
            parent: "market-orders"
          }
        },

        {
          path: "/cafe/dishes",
          name: "cafe-dishes",
          component: () => import("./views/cafe/dishes/Dishes.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Меню", active: true }
            ],
            pageTitle: "Меню"
          }
        },
        {
          path: "/cafe/dishes/:id(\\d+)",
          name: "cafe-dish",
          component: () => import("./views/cafe/dishes/Dish.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Меню", url: "/cafe/dishes" },
              { title: "Блюдо", active: true }
            ],
            pageTitle: "Блюдо",
            parent: "cafe-dishes"
          }
        },
        {
          path: "/cafe/dishes/new",
          name: "new-cafe-dish",
          component: () => import("./views/cafe/dishes/NewDish.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Меню", url: "/cafe/dishes" },
              { title: "Новое блюдо", active: true }
            ],
            pageTitle: "Новое блюдо",
            parent: "cafe-dishes"
          }
        },
        {
          path: "/cafe/orders",
          name: "cafe-orders",
          component: () => import("./views/cafe/orders/Orders.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заказы в Кафе", active: true }
            ],
            pageTitle: "Заказы в Кафе"
          }
        },
        {
          path: "/cafe/orders/:id(\\d+)",
          name: "cafe-order",
          component: () => import("./views/cafe/orders/Order.vue"),
          meta: {
            rule: "admin",
            isAuth: true,
            breadcrumb: [
              { title: "Главная", url: "/" },
              { title: "Заказы в Кафе", url: "/cafe/orders" },
              { title: "Заказ", active: true }
            ],
            pageTitle: "Заказ",
            parent: "cafe-orders"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            rule: "guest"
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "guest"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "guest"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
